<template>
  <AffiliateLandingPage
    imageExt="svg"
    imageName="PerkSpot"
    routePath="perkspot"
    company="PerkSpot"
  />
</template>

<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
  components: {
    AffiliateLandingPage
  },
  name: 'PerkSpotLandingPage'
}
</script>
